<template>
	<div>
		<v-toolbar flat class="sticky-top" color="primary" dark>
			<v-container>
				<v-row align="center">
					<v-col cols="auto">
						<v-toolbar-title> {{ $t("SmartNavBar.My_quotes") }} </v-toolbar-title>
					</v-col>
					<v-spacer />
					
					<v-spacer />
					<v-col cols="auto">
						<v-text-field flat hide-details clearable outlined dense background-color="transparent" class="my-auto"
						:placeholder="$t('Your_reference')" v-model="searchValue" append-icon="mdi-magnify"
						@keyup.native.enter="onSearch" @click:append="onSearch" @click:clear="onClear"
						style="max-width: 250px" />
					</v-col>
				</v-row>
			</v-container>
		</v-toolbar>

		<v-container>
			<v-row justify="center" v-for="quote of quoteList" :key="quote.offertenr">
				<v-col cols="12">
					<QuoteCard :quote="quote" />
				</v-col>
			</v-row>
			<v-row justify="center">
				<v-btn class="my-3" v-if="this.rowIdent" :loading="loading" color="primary" @click="getSalesQuoteList()">
					{{ $t('Load_more') }}
				</v-btn>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import caas from "@/services/caas";
import QuoteCard from "../components/QuoteCard";
export default {
	name: "SalesQuotes",
	components: { QuoteCard },
	data() {
		return {
			loading: false,
			tabId: 0,
			quoteList: [],
			rowsToBatch: 10,
			rowNum: 0,
			rowIdent: "",
			searchValue: "",
		};
	},
	methods: {
		getSalesQuoteList() {
			this.loading = true;
			let params = {
				statusFilter: this.tabId,
				rowNum: this.rowNum,
				rowIdent: this.rowIdent,
				rowsToBatch: this.rowsToBatch,
				search: this.searchValue,
			};
			return caas
				.rpc("getPortalUserQuotes", params)
				.then((response) => {

					this.loading = false;
					if (response.data.success.data) {
						this.quoteList.push(
							...response.data.success.data.quoteView.quote
						);
						this.rowNum = response.data.success.rowNum;
						this.rowIdent = response.data.success.rowIdent;
					} else if (response.data.success.error) {
						throw response.data.success.error;
					}
				})
				.catch((error) => {
					console.log(error.message);
					this.loading = false;
				})
		},
		onTabChanged() {
			this.quoteList = [];
			this.rowNum = 0;
			this.rowIdent = "";
			this.getSalesQuoteList();
		},
		onClear() {
			this.searchValue = "";
			this.onSearch();
		},
		onSearch() {
			this.quoteList = [];
			this.rowNum = 0;
			this.rowIdent = "";
			this.getSalesQuoteList();
		},
	},
	mounted() {
		this.getSalesQuoteList();
	},
};
</script>
